import React, {Component, PropTypes} from 'react';
import {Spin} from 'antd'
import {connect} from 'react-redux';

class SSpin extends Component {
  constructor(props) {
		super(props);
	}
  render() {
    return this.props.showLoading ? (
      <div className="spin-w">
				<Spin/>
      </div>
    ) : null
  }
}


function mapStateToProps({page}) {
	return {
		showLoading: page.showLoading
	}
}

export default connect(mapStateToProps)(SSpin)





// WEBPACK FOOTER //
// ./src/components/common/SSpin/index.js